import React, { FC } from 'react';
import { Card, CardContent, CardHeader, Grid, IconButton, Typography } from '@material-ui/core';
import { InfoIcon, LightTooltip } from '../../../../components';
import { useStyles } from './styles';
import { formatNumber } from '../../../../utils';

interface Props {
  title: string;
  tooltip: string;
  currency: string;
  value: number;
  percentage: number;
  selected: boolean;
  onClick: () => void;
}

export const QuickReport: FC<Props> = ({ title, tooltip, currency, value, percentage, selected, onClick }) => {
  const classes = useStyles();

  return (
    <Card className={`${classes.root} ${selected && classes.selected}`} onClick={onClick}>
      <CardHeader
        action={
          <LightTooltip title={tooltip} arrow placement="right-start">
            <IconButton size="small">
              <InfoIcon />
            </IconButton>
          </LightTooltip>
        }
        title={title}
      />
      <CardContent className={classes.padding}>
        <Typography component="p" className={classes.percentContent}>
          {formatNumber(value, currency)}
        </Typography>
        <Grid className={classes.bottomContent}>
          <Grid className={`${classes.bottomContentItem} ${percentage > 0 ? classes.up : percentage !== 0 && classes.down}`}>
            {percentage > 0
              ? percentage < 100
                ? `+${Number.isInteger(percentage) ? percentage : percentage.toFixed(2)}%`
                : '>+100%'
              : percentage < 0
              ? percentage > -100
                ? `${Number.isInteger(percentage) ? percentage : percentage.toFixed(2)}%`
                : '<-100%'
              : `${percentage}%`}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
